module.exports = __webpack_public_path__ + "static/media/pricing1.fbd55554.jpg";